
export default function(object, propertyStringArray) {
  let value = object;

  for (let i = 0; i < propertyStringArray.length; i++) {
    const prop = propertyStringArray[i];

    if (value[prop]) {
      value = value[prop];
    } else {
      return null;
    }
  }

  return value;
}
